<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Workflow
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)
const headers = [
  {
    field: 'workflowName',
    headerName: $t('labels.workflow')
  },
  {
    field: 'totalOpportunity',
    headerName: $t('labels.businessOpportunityCount'),
    valueGetter: (params: any) => {
      const { totalOpportunity } = params.data
      return $formatters.formatNumber(totalOpportunity || 0)
    }
  },
  {
    field: 'totalQuote',
    headerName: $t('labels.quoteCount'),
    valueGetter: (params: any) => {
      const { totalQuote } = params.data
      return $formatters.formatNumber(totalQuote || 0)
    }
  },
  {
    field: 'totalOrder',
    headerName: $t('labels.orderCount'),
    valueGetter: (params: any) => {
      const { totalOrder } = params.data
      return $formatters.formatNumber(totalOrder || 0)
    }
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getWorkflow, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
